import {
  getDecryptID,
  isEmptyObject,
  StringIsUndefinedOrEmpty,
  checkIfPromoExist,
  calculateSaveEntireAmount,
  arrayForPayFix,
  calculatePayFix,
  getItemsNominated,
  calculatePromoGetItems,
  resetBookPromoQuantity
} from './GlobalMethods'
import {
  promoProdEffect,
  promoProductsEffect,
  isProdInCondition,
  getBuyCount,
  getSpendCount,
  promoProdReqInfo,
  promoCheckProdSuccess
} from './ProdHelperMethods'

export function getProductPriceBook (productID, bookList) {
  let prodBooksList = []

  return () => {
    if (productID && bookList && bookList.length > 0) {
      let prodID = productID.includes('&')
        ? productID.substring(0, productID.indexOf('&'))
        : productID

      bookList.map(e => {
        if (e.productDetails && e.productDetails.length > 0) {
          let prodBook = e.productDetails.filter(
            a => a.productID.substring(0, a.productID.indexOf('&')) == prodID
          )

          if (prodBook.length > 0) {
            let book = {
              priceBookID: '',
              priceBookName: '',
              customerGroupID: '',
              unitPrice: 0,
              discountPercentage: 0,
              markup: 0,
              minUnits: 0,
              maxUnits: 0
            }
            prodBook.map(f => {
              book.priceBookID = e.priceBookID
              book.priceBookName = e.priceBookName
              book.customerGroupID = e.customerGroupID
              book.unitPrice = f.retailPrice
              book.discountPercentage = f.discount
              book.markup = f.markup
              book.minUnits = f.minUnits
              book.maxUnits = f.maxUnits
              prodBooksList.push(book)
              // prodBooksList = prodBooksList.concat(book);
            })
          }
        }
      })
    }

    return prodBooksList
  }
}

export function getProductPromotion (
  productID,
  promoList, //redux stored list
  amount, // prod amount
  quantity, // prod quantity
  customerGroupID, // if any customer added
  promoCode, // if any promo code added (first check if exist then call in loop for added prods)
  prodList,
  unitAmount, // single prod amount,
  prodIdentityInfo // info about cat, skus, tags, brands, supplier
) {
  let filteredPromoList = []
  let prodPromo = {
    id: '',
    name: '',
    amount: 0,
    getAmount: 0,
    isOffEntireSale: false, // if this true must check discountPercentage, if > 0 then convert & apply to whole sale!!
    discountPercentage: 0, //**NOTE */: % is for entire sale & if getItem is in % (cause reward prod amount is not known)
    //NOTE: agar getItem true hai or discountPercentage > 0 hai to pehle quantity ko * kardo prod singl price k sath phr (discountPercetnage/100 * jo b aya amount pehle step se)
    //because prod amount is not known (price book can effect the prices of prod)
    isPayFix: false,
    isGetItem: false,
    isGetFree: false,
    isGetAmount: false,
    getQuantity: 0, // whenever getItem true then must check QUANTITY & discountPercentage!!!
    promoApplyQuantity: 0, //on how many prod promo is applicable
    spendAmount: 0, //on how much amount spend -> promo is applicable
    isGetAllProd: false, // for getItems
    isPromoAllProd: false, // for adv promo apply all prod
    rewardProd: [], //get prods {if (!isGetAllProd && isGetItem) then check if these prods exists in sale then perform accordingly}
    condProds: [], //get prods {if (!isGetAllProd && isGetItem) then these prod would be fulfilling the req to apply promotion}
    codeDetail: {}
  }
  if (productID && promoList && promoList.length > 0) {
    let prodID =
      productID && productID.includes('&')
        ? productID.substring(0, productID.indexOf('&'))
        : false

    let cusGroupID =
      customerGroupID && customerGroupID.includes('&')
        ? customerGroupID.substring(0, customerGroupID.indexOf('&'))
        : false

    let prodQuantity = quantity && quantity > 0 ? quantity : false
    let quantityForBuy = 0
    let amountSpentForAdv = 0
    let prodAmount = amount && amount > 0 ? amount : false

    if (prodID) {
      // // NOTE:making the filtered list where promo exist for this product & target
      promoList.map(e => {
        let isTargetExist = false
        // // NOTE:identify the target
        if (!e.isEveryone) {
          if (promoCode) {
            if (e.promoCodes && e.promoCodes.length > 0) {
              let codePromo = e.promoCodes.filter(
                a => a.codeName.toLowerCase() == promoCode
              )
              if (codePromo && codePromo.length > 0) {
                codePromo = codePromo[0]
                if (
                  codePromo.nbrOfRedemptions == 0 ||
                  codePromo.nbrOfRedemptions > codePromo.nbrOfUsed
                ) {
                  isTargetExist = true
                  prodPromo.codeDetail = codePromo
                }
              }
            }
          } else if (
            cusGroupID != false &&
            e.promoCustomerGroup &&
            e.promoCustomerGroup.length > 0
          ) {
            let customerExist =
              cusGroupID == '0'
                ? [1]
                : e.promoCustomerGroup.filter(
                    a =>
                      getDecryptID(a.sCustomerGroupID) == cusGroupID ||
                      getDecryptID(a.sCustomerGroupID) == 0
                  )
            if (customerExist.length > 0) {
              isTargetExist = true
            }
          }
        } else if (e.isEveryone) {
          isTargetExist = true
        }
        // // NOTE:check if prod exist
        if (isTargetExist) {
          if (!e.isSpecificProduct) {
            prodPromo.isPromoAllProd = true
            filteredPromoList = filteredPromoList.concat(e)
          } else {
            if (e.promoProducts && e.promoProducts.length > 0) {
              // // NOTE: if any product is in exclude then check whether include prod is present or not, if present then those included prod will be consider only and if there is only exclude prods then except this excluded prod evry prod will be considered
              let checkExcluded = e.promoProducts.filter(
                q => q.isExclude == true
              )
              if (checkExcluded.length > 0) {
                // // NOTE:check if prod is in excluded

                // let excludeProdCheck = e.promoProducts.filter(
                //   s =>
                //     s.productID.substring(0, s.productID.indexOf('&')) ==
                //       prodID && s.isExclude == true
                // )
                const excludeProdCheck = promoCheckProdSuccess(
                  e.promoProducts,
                  prodIdentityInfo,
                  true
                )
                // // NOTE:if prod not in excluded then cont
                if (!excludeProdCheck) {
                  // excludeProdCheck.length == 0
                  let checkIncluded = e.promoProducts.filter(
                    w => w.isInclude == true
                  )
                  if (checkIncluded.length > 0) {
                    // let includeProdCheck = e.promoProducts.filter(
                    //   s =>
                    //     s.productID.substring(0, s.productID.indexOf('&')) ==
                    //       prodID && s.isInclude == true
                    // )
                    const includeProdCheck = promoCheckProdSuccess(
                      e.promoProducts,
                      prodIdentityInfo,
                      false
                    )
                    //if prod exist in include
                    if (includeProdCheck) {
                      // includeProdCheck.length > 0
                      filteredPromoList = filteredPromoList.concat(e)
                    }
                  } else {
                    // // NOTE:if there is not any prod is in included then except the excluded prod, all prods are included..!
                    filteredPromoList = filteredPromoList.concat(e)
                  }
                }
              } else {
                // let prodExist = e.promoProducts.filter(
                //   b =>
                //     b.productID.substring(0, b.productID.indexOf('&')) == prodID
                // )
                const prodExist = promoCheckProdSuccess(
                  e.promoProducts,
                  prodIdentityInfo,
                  false
                )
                if (prodExist) {
                  // prodExist.length > 0
                  filteredPromoList = filteredPromoList.concat(e)
                }
              }
            }
          }
        }
      })
      // // NOTE:apply promotion
      if (filteredPromoList.length > 0) {
        let advanceExist = filteredPromoList.filter(a => a.isAdvance == true)
        //advance promo have preference
        if (advanceExist.length > 0) {
          // let latestAdvance = advanceExist.reduce((first, second) =>
          //   first > second ? first : second
          // );

          //NOTE: the advanced promotion that is met first will apply (first advanc promo that fulfils the criteria)
          let promoID = ''
          if (prodAmount && prodQuantity) {
            const amountSpent = prodAmount
            // prodQuantity > 1 ? prodQuantity * prodAmount : prodAmount;

            for (let i = 0; i < advanceExist.length; i++) {
              let buyQuantity = prodQuantity
              let spentTotal = amountSpent
              const prodsInCond = []
              prodList.map(vb => {
                if (advanceExist[i].isSpecificProduct) {
                  const dataPrds = advanceExist[i].promoProducts.filter(
                    ee =>
                      getDecryptID(ee.productID) == getDecryptID(vb.sProductID)
                  )
                  if (dataPrds && dataPrds.length > 0) {
                    prodsInCond.push(vb)
                  }
                } else prodsInCond.push(vb)
              })
              // finalising quantity && amount to check in spend && buy condition
              prodsInCond
                .filter(
                  rt => getDecryptID(rt.sProductID) != getDecryptID(productID)
                )
                .map(po => {
                  buyQuantity += po.displayQuantity
                  spentTotal += po.displayPrice
                })
              if (advanceExist[i].isAdvanceBuy) {
                if (buyQuantity >= advanceExist[i].quantity) {
                  // prodQuantity
                  //for buy case applied quantity required
                  prodPromo.promoApplyQuantity = advanceExist[i].quantity
                  promoID = advanceExist[i].promotionID
                  break
                }
              } else if (advanceExist[i].isAdvanceSpend) {
                if (spentTotal >= advanceExist[i].promotionValue) {
                  // amountSpent
                  prodPromo.spendAmount = advanceExist[i].promotionValue
                  promoID = advanceExist[i].promotionID
                  break
                }
              }
            }

            let selectedPromo =
              promoID != ''
                ? advanceExist.filter(c => c.promotionID == promoID)[0]
                : false

            //apply adv promo
            if (selectedPromo && selectedPromo.rewardSpecifications) {
              prodPromo.id = selectedPromo.promotionID
              prodPromo.name = selectedPromo.promotionName
              let rewards = selectedPromo.rewardSpecifications

              if (rewards.isGetItems) {
                prodPromo.condProds = selectedPromo.promoProducts
                prodPromo.isGetItem = true
                prodPromo.getQuantity = rewards.quantity
                if (rewards.isGetFree) {
                  prodPromo.isGetFree = true
                } else if (rewards.isGetPercentage) {
                  prodPromo.discountPercentage = rewards.rewardValue
                  //NOTE: agar getItem true hai or discountPercentage > 0 hai to pehle quantity ko * kardo prod singl price k sath phr (discountPercetnage/100 * jo b aya amount pehle step se)
                  //because prod amount is not known (price book can effect the prices of prod)
                } else if (rewards.isGetAmount) {
                  //NOTE: agar getItem true hai or discountPercentage > 0 "NAHI" hai to simply jese hi quantity match kar jaye reward Prod ki to uski total amount se ye wali amount minus!
                  prodPromo.amount = rewards.rewardValue
                  prodPromo.isGetAmount = rewards.isGetAmount
                }

                //for reward products
                if (rewards.isSpecificProduct) {
                  if (
                    rewards.rewardProducts &&
                    rewards.rewardProducts.length > 0
                  ) {
                    let includedGetProd = rewards.rewardProducts.filter(
                      o => o.isInclude == true
                    )
                    if (includedGetProd.length > 0) {
                      prodPromo.rewardProd =
                        prodPromo.rewardProd.concat(includedGetProd)
                    }
                  }
                } else {
                  prodPromo.isGetAllProd = true
                }
              } else if (rewards.isSave) {
                prodPromo.isOffEntireSale = true
                if (rewards.isSavePercent) {
                  prodPromo.discountPercentage = rewards.rewardValue
                } else {
                  prodPromo.amount = rewards.rewardValue
                }
              } else if (rewards.isFixPay) {
                prodPromo.condProds = selectedPromo.promoProducts
                prodPromo.isPayFix = true
                prodPromo.amount = rewards.rewardValue
              }
            }
          }
        } else {
          //for basic promo
          if (unitAmount) {
            //  && quantity
            let selectedBasicPromo = {}
            if (filteredPromoList.length > 1) {
              let bigDiscountPromo = filteredPromoList.reduce(
                (first, second) => {
                  let firsAmount = first.promotionValue
                  let secondAmount = second.promotionValue
                  if (first.isPercentage) {
                    firsAmount = (firsAmount / 100) * unitAmount
                  }
                  if (second.isPercentage) {
                    secondAmount = (secondAmount / 100) * unitAmount
                  }
                  return firsAmount > secondAmount ? first : second
                }
              )

              selectedBasicPromo = { ...bigDiscountPromo }
            } else {
              selectedBasicPromo = { ...filteredPromoList[0] }
            }

            //apply basic promo
            if (selectedBasicPromo && selectedBasicPromo.promotionID) {
              prodPromo.id = selectedBasicPromo.promotionID
              prodPromo.name = selectedBasicPromo.promotionName
              let amountBasicSpent = unitAmount
              // prodQuantity > 1 ? prodQuantity * prodAmount : prodAmount;
              let discountAmount = selectedBasicPromo.promotionValue
              // prodQuantity > 1
              //   ? prodQuantity * selectedBasicPromo.promotionValue
              //   : selectedBasicPromo.promotionValue;

              if (selectedBasicPromo.isPercentage) {
                discountAmount = (discountAmount / 100) * amountBasicSpent
              }

              prodPromo.amount = discountAmount
            }
          }
        }
      }
    }
  }

  if (prodPromo && !isEmptyObject(prodPromo) && prodPromo.amount) {
    prodPromo.getAmount = prodPromo.amount
  }
  return prodPromo
}

export function calculatePromotion (
  items,
  getReduxSaleProductJsonData,
  promotionDataByProductID,
  displayQuantity,
  grandTotalQuantity,
  productRowKey,
  referencePromotion,
  bestPriceBookInfo,
  builderType,
  getCustomerSearchData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getStoredPromos,
  getDefaultDecimalPlaces,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getIsRefundSale,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  appliedPromotionObject,
  isPromotionApplied,
  getRefundKeys,
  getSalePayments,
  dispatch,
  getSavings,
  attribProps
) {
  let isEntirePromoEffect = false
  const pricee = getIsTaxExclusive
    ? bestPriceBookInfo.price
    : bestPriceBookInfo.price + bestPriceBookInfo.tax
  if (
    promotionDataByProductID != undefined &&
    !isEmptyObject(promotionDataByProductID) &&
    promotionDataByProductID.name != '' &&
    promotionDataByProductID.id != ''
  ) {
    promotionDataByProductID.key = productRowKey
    referencePromotion = { ...promotionDataByProductID }

    if (getReduxSaleProductJsonData && getReduxSaleProductJsonData.length > 0) {
      //Already Items in cart

      const isCertainAmount = promotionDataByProductID.isOffEntireSale //Entire Sale Off
      const isPayFixed = promotionDataByProductID.isPayFix
      const isGetItem = promotionDataByProductID.isGetItem
      const getQuantity = promotionDataByProductID.getQuantity
      const applyQuantity = promotionDataByProductID.promoApplyQuantity
      const spentAmount = promotionDataByProductID.spendAmount
      const condProds =
        promotionDataByProductID &&
        promotionDataByProductID.condProds && // condition prods
        promotionDataByProductID.condProds.length > 0
          ? promotionDataByProductID.condProds
          : []
      const rewardProd =
        promotionDataByProductID &&
        promotionDataByProductID.rewardProd &&
        promotionDataByProductID.rewardProd.length > 0
          ? promotionDataByProductID.rewardProd
          : []

      if (isCertainAmount) {
        //Entire Sale Off
        var isDiscountPercentage =
          promotionDataByProductID.discountPercentage >= 1 &&
          promotionDataByProductID.discountPercentage <= 100 &&
          promotionDataByProductID.amount == 0
            ? true
            : false
        var isAmount =
          promotionDataByProductID.amount > 0 &&
          promotionDataByProductID.discountPercentage == 0
            ? true
            : false

        if (isAmount) {
          var saleProductJsonList = getReduxSaleProductJsonData
          var totalProductQuantity = grandTotalQuantity
          saleProductJsonList
            .filter(
              w => getDecryptID(w.sProductID) != getDecryptID(items.sProductID)
            )
            .map(e => {
              totalProductQuantity += e.displayQuantity
            })

          // let eachRowPromotionAmount =
          //   promotionDataByProductID.amount / getReduxSaleProductJsonData.length; //totalProductQuantity
          // appliedPromotionObject.amount = eachRowPromotionAmount;
          const entireDisc = promotionDataByProductID.amount
            ? promotionDataByProductID.amount
            : 0
          appliedPromotionObject = promotionDataByProductID
          appliedPromotionObject.isExistingPromotion = true

          promoProductsEffect(
            'certainAmountCash',
            saleProductJsonList,
            appliedPromotionObject,
            builderType,
            getCustomerSearchData,
            saleProductJsonList, //getReduxSaleProductJsonData,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getDefaultDecimalPlaces,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getIsRefundSale,
            getCurrentSalesOrderData,
            getCurrentSalesOrderStatusID,
            formDiscountPrice,
            formDiscountPercentage,
            formSellNotes,
            getRefundKeys,
            getSalePayments,
            dispatch,
            false,
            promotionDataByProductID,
            false,
            getSavings,
            bestPriceBookInfo,
            items,
            attribProps
          )
          appliedPromotionObject.amount = calculateSaveEntireAmount(
            items,
            saleProductJsonList,
            entireDisc,
            bestPriceBookInfo,
            bestPriceBookInfo.price
              ? bestPriceBookInfo.price * items.displayQuantity
              : 0
          )
          isPromotionApplied = true
          isEntirePromoEffect = true
        } else {
          //Is case me percentage ayegi jo hamen hr row pr lagani hogi
          if (isDiscountPercentage) {
            // 0  sy 100 tk rane
            let updatedPromotionObject = promotionDataByProductID
            promoProductsEffect(
              'certainAmountPercent',
              getReduxSaleProductJsonData,
              updatedPromotionObject,
              builderType,
              getCustomerSearchData,
              getReduxSaleProductJsonData,
              getStoredBooks,
              getIsLoyaltyEnabled,
              getDefaultLoyaltyAmount,
              getIsTaxExclusive,
              getStoredPromos,
              getDefaultDecimalPlaces,
              getSelectedOutlet,
              getSelectedReg,
              getBasicIsPercent,
              getIsRefundSale,
              getCurrentSalesOrderData,
              getCurrentSalesOrderStatusID,
              formDiscountPrice,
              formDiscountPercentage,
              formSellNotes,
              getRefundKeys,
              getSalePayments,
              dispatch,
              '',
              promotionDataByProductID,
              false,
              getSavings,
              bestPriceBookInfo,
              items,
              attribProps
            )
            let currentRowPromotionAmount =
              ((pricee * displayQuantity) / 100) *
              promotionDataByProductID.discountPercentage
            appliedPromotionObject = promotionDataByProductID
            // appliedPromotionObject.isExistingPromotion = true;
            isPromotionApplied = true
            appliedPromotionObject.amount = currentRowPromotionAmount
            isEntirePromoEffect = true
          }
        }
      } else if (isPayFixed) {
        // referencePromotion = {}; //no need to hold ref for fix Price of a prod
        appliedPromotionObject = promotionDataByProductID
        appliedPromotionObject.isExistingPromotion = true
        const promoData = arrayForPayFix(
          items,
          getReduxSaleProductJsonData,
          bestPriceBookInfo,
          appliedPromotionObject.amount,
          applyQuantity,
          condProds,
          getIsTaxExclusive,
          appliedPromotionObject.isPromoAllProd
        )
        const arrayProds = promoData.finalProds
        appliedPromotionObject.fixPriceTotal = promoData.fixPriceTotal
        appliedPromotionObject.buyTotal = promoData.buyTotal
        promoProductsEffect(
          'payFix',
          arrayProds, // only those prods upon which promo will apply
          appliedPromotionObject,
          builderType,
          getCustomerSearchData,
          getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscountPrice,
          formDiscountPercentage,
          formSellNotes,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          promotionDataByProductID,
          false,
          getSavings,
          bestPriceBookInfo,
          items,
          attribProps
        )
        const incomeProdIdentify =
          arrayProds.filter(a => a.key == items.key).length > 0
            ? arrayProds.filter(a => a.key == items.key)[0]
            : {}
        let amountCheck = 0
        if (incomeProdIdentify && !isEmptyObject(incomeProdIdentify)) {
          amountCheck = calculatePayFix(
            arrayProds,
            bestPriceBookInfo,
            getIsTaxExclusive,
            appliedPromotionObject.buyTotal,
            appliedPromotionObject.fixPriceTotal,
            incomeProdIdentify.promoIndex != undefined &&
              incomeProdIdentify.promoIndex != null
              ? incomeProdIdentify.promoIndex
              : ''
          )
          if (amountCheck) {
            appliedPromotionObject.amount = amountCheck
          }
        }

        // if promo is now not applicable then remove it from those prods
        const removeArr = checkIfPromoExist(
          items,
          getReduxSaleProductJsonData,
          arrayProds,
          promotionDataByProductID.name
        )
        if (removeArr && Array.isArray(removeArr) && removeArr.length > 0) {
          promoProductsEffect(
            'toRemovePromo',
            removeArr, // only those prods upon which promo will apply
            appliedPromotionObject,
            builderType,
            getCustomerSearchData,
            getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getDefaultDecimalPlaces,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getIsRefundSale,
            getCurrentSalesOrderData,
            getCurrentSalesOrderStatusID,
            formDiscountPrice,
            formDiscountPercentage,
            formSellNotes,
            getRefundKeys,
            getSalePayments,
            dispatch,
            false,
            promotionDataByProductID,
            false,
            getSavings,
            bestPriceBookInfo,
            items,
            attribProps
          )
        }

        if (amountCheck) {
          // appliedPromotionObject = promotionDataByProductID;
          isPromotionApplied = true
        } else {
          appliedPromotionObject = {}
          isPromotionApplied = false
          referencePromotion = {}
          promotionDataByProductID = {}
        }
      } else if (isGetItem) {
        if (getQuantity > 0) {
          const isGetAllProd = promotionDataByProductID.isGetAllProd
          const isPromoAllProd = promotionDataByProductID.isPromoAllProd
          const isFree = promotionDataByProductID.isGetFree
          const isDiscountPercentage =
            promotionDataByProductID.discountPercentage > 0 &&
            !promotionDataByProductID.isGetAmount
              ? true
              : false
          const isAmount =
            promotionDataByProductID.amount > 0 &&
            promotionDataByProductID.isGetAmount
              ? true
              : false
          if (isDiscountPercentage || isAmount || isFree) {
            let type = false
            if (isFree) {
              type = 'getItems_getFree'
            } else if (isDiscountPercentage) {
              type = 'getItems_getPercent'
            } else if (isAmount) {
              type = 'getItems_getAmount'
            }
            appliedPromotionObject = promotionDataByProductID
            appliedPromotionObject.isExistingPromotion = true
            const arrData = getItemsNominated(
              items,
              getReduxSaleProductJsonData,
              bestPriceBookInfo,
              condProds,
              rewardProd,
              applyQuantity,
              spentAmount,
              getQuantity,
              isGetAllProd,
              isPromoAllProd,
              getIsTaxExclusive,
              type
            )
            if (
              arrData &&
              Array.isArray(arrData) &&
              arrData.length > 0 &&
              type
            ) {
              promoProductsEffect(
                type,
                arrData, // only those prods upon which promo will apply
                appliedPromotionObject,
                builderType,
                getCustomerSearchData,
                getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscountPrice,
                formDiscountPercentage,
                formSellNotes,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                promotionDataByProductID,
                false,
                getSavings,
                bestPriceBookInfo,
                items,
                attribProps
              )
            } else {
              appliedPromotionObject = {}
              appliedPromotionObject.isExistingPromotion = false
            }
            const isComingExist =
              arrData && Array.isArray(arrData) && arrData.length > 0
                ? arrData.filter(fg => fg.key == items.key)
                : []
            let checkAmount = 0
            if (
              isComingExist &&
              isComingExist.length > 0 &&
              isComingExist[0].promoQuantity
            ) {
              const priceItem = getIsTaxExclusive
                ? bestPriceBookInfo.price
                : bestPriceBookInfo.price + bestPriceBookInfo.tax
              const amountData = calculatePromoGetItems(
                type,
                priceItem,
                appliedPromotionObject.discountPercentage,
                appliedPromotionObject.getAmount,
                isComingExist[0].displayQuantity,
                isComingExist[0].promoQuantity
              )
              checkAmount = amountData ? amountData : 0
              if (checkAmount) {
                appliedPromotionObject.amount = checkAmount
              }
            }
            // if promo is now not applicable then remove it from those prods
            const removeArr = checkIfPromoExist(
              items,
              getReduxSaleProductJsonData,
              arrData,
              promotionDataByProductID.name
            )
            if (removeArr && Array.isArray(removeArr) && removeArr.length > 0) {
              promoProductsEffect(
                'toRemovePromo',
                removeArr, // only those prods upon which promo will apply
                appliedPromotionObject,
                builderType,
                getCustomerSearchData,
                getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscountPrice,
                formDiscountPercentage,
                formSellNotes,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                promotionDataByProductID,
                false,
                getSavings,
                bestPriceBookInfo,
                items,
                attribProps
              )
            }
            if (checkAmount) {
              // appliedPromotionObject = promotionDataByProductID;
              isPromotionApplied = true
            } else {
              // appliedPromotionObject = {};
              isPromotionApplied = false
              // referencePromotion = {};
              promotionDataByProductID = {}
            }
            resetBookPromoQuantity(items, getReduxSaleProductJsonData)
          }
        }
      } else {
        //basic promotions
        appliedPromotionObject = promotionDataByProductID
        isPromotionApplied = true
      }
    } else {
      //First prod enters in cart

      const isCertainAmount = promotionDataByProductID.isOffEntireSale //Entire Sale Off
      const isPayFixed = promotionDataByProductID.isPayFix
      const isGetItem = promotionDataByProductID.isGetItem
      const getQuantity = promotionDataByProductID.getQuantity
      const applyQuantity = promotionDataByProductID.promoApplyQuantity
      const spentAmount = promotionDataByProductID.spendAmount

      if (isCertainAmount) {
        //Entire Sale Off

        let isDiscountPercentage =
          promotionDataByProductID.discountPercentage >= 1 &&
          promotionDataByProductID.discountPercentage <= 100 &&
          promotionDataByProductID.amount == 0
            ? true
            : false
        let isAmount =
          promotionDataByProductID.amount > 0 &&
          promotionDataByProductID.discountPercentage == 0
            ? true
            : false

        if (isAmount) {
          appliedPromotionObject = promotionDataByProductID
          isPromotionApplied = true
        } else {
          if (isDiscountPercentage) {
            // 0  sy 100 tk rane
            let currentRowPromotionAmount =
              (pricee / 100) * promotionDataByProductID.discountPercentage
            appliedPromotionObject = promotionDataByProductID
            appliedPromotionObject.amount = currentRowPromotionAmount
            isPromotionApplied = true
          }
        }
      } else if (isPayFixed) {
        appliedPromotionObject = promotionDataByProductID
        isPromotionApplied = true
      } else if (isGetItem) {
        if (getQuantity > 0) {
          const isGetAllProd = promotionDataByProductID.isGetAllProd
          const isPromoAllProd = promotionDataByProductID.isPromoAllProd
          const isFree = promotionDataByProductID.isGetFree
          const isDiscountPercentage =
            promotionDataByProductID.discountPercentage > 0 &&
            !promotionDataByProductID.isGetAmount
              ? true
              : false
          const isAmount =
            promotionDataByProductID.amount > 0 &&
            promotionDataByProductID.isGetAmount
              ? true
              : false
          const condProds =
            promotionDataByProductID &&
            promotionDataByProductID.condProds && // condition prods
            promotionDataByProductID.condProds.length > 0
              ? promotionDataByProductID.condProds
              : []
          const rewardProd =
            promotionDataByProductID &&
            promotionDataByProductID.rewardProd &&
            promotionDataByProductID.rewardProd.length > 0
              ? promotionDataByProductID.rewardProd
              : []
          if (isDiscountPercentage || isAmount || isFree) {
            let type = false
            appliedPromotionObject = promotionDataByProductID
            appliedPromotionObject.isExistingPromotion = true
            if (isFree) {
              type = 'getItems_getFree'
            } else if (isDiscountPercentage) {
              type = 'getItems_getPercent'
            } else if (isAmount) {
              type = 'getItems_getAmount'
            }
            const arrData = getItemsNominated(
              items,
              getReduxSaleProductJsonData,
              bestPriceBookInfo,
              condProds,
              rewardProd,
              applyQuantity,
              spentAmount,
              getQuantity,
              isGetAllProd,
              isPromoAllProd,
              getIsTaxExclusive,
              type
            )
            if (
              arrData &&
              Array.isArray(arrData) &&
              arrData.length > 0 &&
              type
            ) {
              let amountPrice = 0
              if (arrData[0].promoQuantity) {
                const priceItem = getIsTaxExclusive
                  ? arrData[0].bestPriceBookInfo.price
                  : arrData[0].bestPriceBookInfo.price +
                    arrData[0].bestPriceBookInfo.tax
                const promoValue = appliedPromotionObject.getAmount
                  ? appliedPromotionObject.getAmount
                  : 0
                const promoDiscount = appliedPromotionObject.discountPercentage
                  ? appliedPromotionObject.discountPercentage
                  : 0
                amountPrice = calculatePromoGetItems(
                  type,
                  priceItem,
                  promoDiscount,
                  promoValue,
                  arrData[0].displayQuantity,
                  arrData[0].promoQuantity
                )
              }
              if (amountPrice > 0) {
                appliedPromotionObject.amount = amountPrice
                appliedPromotionObject.isExistingPromotion = true
              } else {
                appliedPromotionObject = {}
                appliedPromotionObject.isExistingPromotion = false
              }
            } else {
              appliedPromotionObject = {}
              appliedPromotionObject.isExistingPromotion = false
            }
            const isComingExist =
              arrData && Array.isArray(arrData) && arrData.length > 0
                ? arrData.filter(fg => fg.key == items.key)
                : []
            let checkAmount = 0
            if (
              isComingExist &&
              isComingExist.length > 0 &&
              isComingExist[0].promoQuantity
            ) {
              const priceItem = getIsTaxExclusive
                ? bestPriceBookInfo.price
                : bestPriceBookInfo.price + bestPriceBookInfo.tax
              const amountData = calculatePromoGetItems(
                type,
                priceItem,
                appliedPromotionObject.discountPercentage,
                appliedPromotionObject.getAmount,
                isComingExist[0].displayQuantity,
                isComingExist[0].promoQuantity
              )
              checkAmount = amountData ? amountData : 0
              if (checkAmount) {
                appliedPromotionObject.amount = checkAmount
              }
            }
            // if promo is now not applicable then remove it from those prods
            const removeArr = checkIfPromoExist(
              items,
              getReduxSaleProductJsonData,
              arrData,
              promotionDataByProductID.name
            )
            if (removeArr && Array.isArray(removeArr) && removeArr.length > 0) {
              promoProductsEffect(
                'toRemovePromo',
                removeArr, // only those prods upon which promo will apply
                appliedPromotionObject,
                builderType,
                getCustomerSearchData,
                getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscountPrice,
                formDiscountPercentage,
                formSellNotes,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                promotionDataByProductID,
                false,
                getSavings,
                bestPriceBookInfo,
                items,
                attribProps
              )
            }
            if (checkAmount) {
              // appliedPromotionObject = promotionDataByProductID;
              isPromotionApplied = true
            } else {
              // appliedPromotionObject = {};
              isPromotionApplied = false
              // referencePromotion = {};
              promotionDataByProductID = {}
            }
            resetBookPromoQuantity(items, getReduxSaleProductJsonData)
          }
        }
      } else {
        //basic promotions
        appliedPromotionObject = promotionDataByProductID
        isPromotionApplied = true
      }
    }
  } else {
    //Agr Promotion Nhi mili that case
    const calculateRefPromo = checkRefPromotion(
      items,
      getReduxSaleProductJsonData,
      promotionDataByProductID,
      displayQuantity,
      grandTotalQuantity,
      productRowKey,
      referencePromotion,
      bestPriceBookInfo,
      builderType,
      getCustomerSearchData,
      getStoredBooks,
      getIsLoyaltyEnabled,
      getDefaultLoyaltyAmount,
      getIsTaxExclusive,
      getStoredPromos,
      getDefaultDecimalPlaces,
      getSelectedOutlet,
      getSelectedReg,
      getBasicIsPercent,
      getIsRefundSale,
      getCurrentSalesOrderData,
      getCurrentSalesOrderStatusID,
      formDiscountPrice,
      formDiscountPercentage,
      formSellNotes,
      appliedPromotionObject,
      isPromotionApplied,
      getRefundKeys,
      getSalePayments,
      dispatch,
      getSavings,
      attribProps
    )
    if (calculateRefPromo && !isEmptyObject(calculateRefPromo)) {
      appliedPromotionObject = calculateRefPromo.appliedObj
      isPromotionApplied = calculateRefPromo.isApplied
      referencePromotion = calculateRefPromo.refPromo
      isEntirePromoEffect = calculateRefPromo.isEntirePromoEffect
    }
  }

  return {
    appliedObj: appliedPromotionObject,
    isApplied: isPromotionApplied,
    refPromo: referencePromotion,
    isEntirePromoEffect: isEntirePromoEffect
  }
}

export function checkRefPromotion (
  items,
  getReduxSaleProductJsonData,
  promotionDataByProductID,
  displayQuantity,
  grandTotalQuantity,
  productRowKey,
  referencePromotion,
  bestPriceBookInfo,
  builderType,
  getCustomerSearchData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getStoredPromos,
  getDefaultDecimalPlaces,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getIsRefundSale,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  appliedPromotionObject,
  isPromotionApplied,
  getRefundKeys,
  getSalePayments,
  dispatch,
  getSavings,
  attribProps
) {
  const priceV = getIsTaxExclusive
    ? bestPriceBookInfo.price
    : bestPriceBookInfo.price + bestPriceBookInfo.tax
  let refPromoProd = {}
  let isEntirePromoEffect = false
  if (getReduxSaleProductJsonData && getReduxSaleProductJsonData.length > 0) {
    var saleProductJsonList = getReduxSaleProductJsonData
    var referencePromotionArray = []

    saleProductJsonList.map(saleProductData => {
      if (
        saleProductData.PromotionandPriceBookDetails != null &&
        !isEmptyObject(saleProductData.PromotionandPriceBookDetails)
      ) {
        if (
          saleProductData.PromotionandPriceBookDetails.ReferencePromotion &&
          !isEmptyObject(
            saleProductData.PromotionandPriceBookDetails.ReferencePromotion
          )
        ) {
          referencePromotionArray.push(
            saleProductData.PromotionandPriceBookDetails.ReferencePromotion
          )
          // refPromoProd = saleProductData;
          // if (getDecryptID(refPromoProd.sProductID) == getDecryptID(items.sProductID)) {
          //   refPromoProd = items;
          // }
        }
      }
    })

    let followingItemsPromotion = []
    let entireSaleOffPromotion = []
    let fixedPricePromotions = []

    referencePromotionArray &&
      referencePromotionArray.map(obj => {
        if (obj.isGetItem) {
          followingItemsPromotion.push(obj)
        }
        if (obj.isOffEntireSale) {
          entireSaleOffPromotion.push(obj)
        }
        if (obj.isPayFix) {
          fixedPricePromotions.push(obj)
        }
      })
    if (
      referencePromotionArray != undefined &&
      referencePromotionArray.length > 0
    ) {
      if (
        entireSaleOffPromotion != undefined &&
        entireSaleOffPromotion.length > 0
      ) {
        // let amountPromotion = Math.max.apply(Math, entireSaleOffPromotion.map(function(o) { return o.amount; }));
        // let discountPercentagePromotion =  Math.max.apply(Math, entireSaleOffPromotion.map(function(o) { return o.discountPercentage; }))

        let maxAmountPromotionObj = entireSaleOffPromotion.reduce(function (
          prev,
          current
        ) {
          return prev.amount > current.amount ? prev : current
        })

        let maxDiscountPercentagePromotionObj = entireSaleOffPromotion.reduce(
          function (prev, current) {
            return prev.discountPercentage > current.discountPercentage
              ? prev
              : current
          }
        )
        var nominatedPromo = {}

        if (maxAmountPromotionObj && maxDiscountPercentagePromotionObj) {
          //Entire Sale Off
          const pricee = getIsTaxExclusive
            ? bestPriceBookInfo.price
            : bestPriceBookInfo.price + bestPriceBookInfo.tax
          var isDiscountPercentage =
            maxDiscountPercentagePromotionObj.discountPercentage >= 1 &&
            maxDiscountPercentagePromotionObj.discountPercentage <= 100 &&
            maxDiscountPercentagePromotionObj.amount == 0
              ? true
              : false
          var isAmount =
            maxAmountPromotionObj.amount > 0 &&
            maxAmountPromotionObj.discountPercentage == 0
              ? true
              : false

          if (isAmount) {
            var saleProductJsonList = getReduxSaleProductJsonData
            var totalProductQuantity = grandTotalQuantity
            saleProductJsonList
              .filter(
                w =>
                  getDecryptID(w.sProductID) != getDecryptID(items.sProductID)
              )
              .map(e => {
                totalProductQuantity += e.displayQuantity
              })

            // let eachRowPromotionAmount =
            //   maxAmountPromotionObj.amount / getReduxSaleProductJsonData.length; //totalProductQuantity
            // appliedPromotionObject.amount = eachRowPromotionAmount;
            const entireDisc = maxAmountPromotionObj.amount
              ? maxAmountPromotionObj.amount
              : 0
            appliedPromotionObject = maxAmountPromotionObj
            appliedPromotionObject.isExistingPromotion = true

            promoProductsEffect(
              'certainAmountCash',
              saleProductJsonList,
              appliedPromotionObject,
              builderType,
              getCustomerSearchData,
              saleProductJsonList, //getReduxSaleProductJsonData,
              getStoredBooks,
              getIsLoyaltyEnabled,
              getDefaultLoyaltyAmount,
              getIsTaxExclusive,
              getStoredPromos,
              getDefaultDecimalPlaces,
              getSelectedOutlet,
              getSelectedReg,
              getBasicIsPercent,
              getIsRefundSale,
              getCurrentSalesOrderData,
              getCurrentSalesOrderStatusID,
              formDiscountPrice,
              formDiscountPercentage,
              formSellNotes,
              getRefundKeys,
              getSalePayments,
              dispatch,
              false,
              maxAmountPromotionObj,
              false,
              getSavings,
              bestPriceBookInfo,
              items,
              attribProps
            )
            appliedPromotionObject.amount = calculateSaveEntireAmount(
              items,
              saleProductJsonList,
              entireDisc,
              bestPriceBookInfo,
              bestPriceBookInfo.price
                ? bestPriceBookInfo.price * items.displayQuantity
                : 0
            )
            isPromotionApplied = true
            isEntirePromoEffect = true
          } else {
            //Is case me percentage ayegi jo hamen hr row pr lagani hogi
            if (isDiscountPercentage) {
              // 0  sy 100 tk rane
              let updatedPromotionObject = maxDiscountPercentagePromotionObj
              promoProductsEffect(
                'certainAmountPercent',
                getReduxSaleProductJsonData,
                updatedPromotionObject,
                builderType,
                getCustomerSearchData,
                getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscountPrice,
                formDiscountPercentage,
                formSellNotes,
                getRefundKeys,
                getSalePayments,
                dispatch,
                '',
                maxDiscountPercentagePromotionObj,
                false,
                getSavings,
                bestPriceBookInfo,
                items,
                attribProps
              )
              let currentRowPromotionAmount =
                ((pricee * displayQuantity) / 100) *
                maxDiscountPercentagePromotionObj.discountPercentage
              appliedPromotionObject = maxDiscountPercentagePromotionObj
              // appliedPromotionObject.isExistingPromotion = true;
              isPromotionApplied = true
              appliedPromotionObject.amount = currentRowPromotionAmount
              isEntirePromoEffect = true
            }
          }
        }
      } else if (
        fixedPricePromotions != undefined &&
        fixedPricePromotions.length > 0
      ) {
        // all scenarios handled above(not required this check)
        var nominatedPromo = fixedPricePromotions[0]
        const applyQuantity = nominatedPromo.promoApplyQuantity
        const condProds =
          nominatedPromo &&
          nominatedPromo.condProds && // condition prods
          nominatedPromo.condProds.length > 0
            ? nominatedPromo.condProds
            : []
        appliedPromotionObject = nominatedPromo
        appliedPromotionObject.isExistingPromotion = true
        const promoData = arrayForPayFix(
          items,
          getReduxSaleProductJsonData,
          bestPriceBookInfo,
          appliedPromotionObject.amount,
          applyQuantity,
          condProds,
          getIsTaxExclusive,
          appliedPromotionObject.isPromoAllProd
        )
        const arrayProds = promoData.finalProds
        appliedPromotionObject.fixPriceTotal = promoData.fixPriceTotal
        appliedPromotionObject.buyTotal = promoData.buyTotal
        promoProductsEffect(
          'payFix',
          arrayProds, // only those prods upon which promo will apply
          appliedPromotionObject,
          builderType,
          getCustomerSearchData,
          getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscountPrice,
          formDiscountPercentage,
          formSellNotes,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          nominatedPromo,
          false,
          getSavings,
          bestPriceBookInfo,
          items,
          attribProps
        )
        const incomeProdIdentify =
          arrayProds.filter(a => a.key == items.key).length > 0
            ? arrayProds.filter(a => a.key == items.key)[0]
            : {}
        let amountCheck = 0
        if (incomeProdIdentify && !isEmptyObject(incomeProdIdentify)) {
          amountCheck = calculatePayFix(
            arrayProds,
            bestPriceBookInfo,
            getIsTaxExclusive,
            appliedPromotionObject.buyTotal,
            appliedPromotionObject.fixPriceTotal,
            incomeProdIdentify.promoIndex != undefined &&
              incomeProdIdentify.promoIndex != null
              ? incomeProdIdentify.promoIndex
              : ''
          )
          if (amountCheck) {
            appliedPromotionObject.amount = amountCheck
          }
        }

        // if promo is now not applicable then remove it from those prods
        const removeArr = checkIfPromoExist(
          items,
          getReduxSaleProductJsonData,
          arrayProds,
          nominatedPromo.name
        )
        if (removeArr && Array.isArray(removeArr) && removeArr.length > 0) {
          promoProductsEffect(
            'toRemovePromo',
            removeArr, // only those prods upon which promo will apply
            appliedPromotionObject,
            builderType,
            getCustomerSearchData,
            getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getDefaultDecimalPlaces,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getIsRefundSale,
            getCurrentSalesOrderData,
            getCurrentSalesOrderStatusID,
            formDiscountPrice,
            formDiscountPercentage,
            formSellNotes,
            getRefundKeys,
            getSalePayments,
            dispatch,
            false,
            nominatedPromo,
            false,
            getSavings,
            bestPriceBookInfo,
            items,
            attribProps
          )
        }

        if (amountCheck) {
          // appliedPromotionObject = nominatedPromo;
          isPromotionApplied = true
        } else {
          appliedPromotionObject = {}
          isPromotionApplied = false
          referencePromotion = {}
          promotionDataByProductID = {}
        }
      } else if (
        followingItemsPromotion != undefined &&
        followingItemsPromotion.length > 0
      ) {
        var nominatedPromo = followingItemsPromotion[0]
        let is_Remove = false

        var nominatedPromoProd = getReduxSaleProductJsonData.filter(
          a => a.key == nominatedPromo.key
        )
        let isSpend_Amount = nominatedPromo.spendAmount > 0 ? true : false
        //checking if promo has to remove or implement
        // if (nominatedPromoProd && nominatedPromoProd.length > 0) {
        //   nominatedPromoProd = nominatedPromoProd[0];
        //   if (isSpend_Amount) {
        //     let prod_Price = 0;
        //     //inclusive
        //     let forSpend_TotalProds = getReduxSaleProductJsonData.filter(ss => getDecryptID(ss.sProductID) == getDecryptID(nominatedPromoProd.sProductID));
        //     let itemPrice = 0;
        //     if (!items.key) {
        //       itemPrice = getIsTaxExclusive ?
        //         bestPriceBookInfo.price :
        //         bestPriceBookInfo.price + bestPriceBookInfo.tax;
        //     } else {
        //       itemPrice = getIsTaxExclusive ?
        //         items.bestPriceBookInfo.price :
        //         items.bestPriceBookInfo.price + items.bestPriceBookInfo.tax;
        //     }
        //     if (forSpend_TotalProds.length > 1) {
        //       forSpend_TotalProds.map(ew => {
        //         const ewPrice = getIsTaxExclusive ?
        //           ew.bestPriceBookInfo.price :
        //           ew.bestPriceBookInfo.price + ew.bestPriceBookInfo.tax;
        //         if (items.key && items.key == ew.key) {
        //           prod_Price += itemPrice * displayQuantity;
        //         }
        //         else {
        //           prod_Price += ewPrice * ew.displayQuantity;
        //         }
        //       });
        //     }
        //     else {
        //       const nomPrice = getIsTaxExclusive ?
        //         nominatedPromoProd.bestPriceBookInfo.price :
        //         nominatedPromoProd.bestPriceBookInfo.price + nominatedPromoProd.bestPriceBookInfo.tax;
        //       prod_Price = items.key && items.key == nominatedPromoProd.key ?
        //         itemPrice * displayQuantity
        //         : nomPrice * nominatedPromoProd.displayQuantity;
        //     }
        //     is_Remove = prod_Price < nominatedPromo.spendAmount ? true : false;
        //   }
        //   else {
        //     let prod_Quantity = nominatedPromoProd.grandTotalQuantity;
        //     if (items.key && items.key == nominatedPromoProd.key) {
        //       prod_Quantity = grandTotalQuantity;
        //     }
        //     is_Remove = prod_Quantity < nominatedPromo.promoApplyQuantity ? true : false;
        //   }
        // }
        ///
        if (false) {
          //is_Remove
          appliedPromotionObject = {}
          isPromotionApplied = false
          let list_Prods = getReduxSaleProductJsonData
          list_Prods.map(a => {
            if (a.key == nominatedPromo.key) {
              a.PromotionandPriceBookDetails.ReferencePromotion = {}
            }
          })
          promoProductsEffect(
            'getItemRemove',
            list_Prods,
            appliedPromotionObject,
            builderType,
            getCustomerSearchData,
            list_Prods, //getReduxSaleProductJsonData,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getDefaultDecimalPlaces,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getIsRefundSale,
            getCurrentSalesOrderData,
            getCurrentSalesOrderStatusID,
            formDiscountPrice,
            formDiscountPercentage,
            formSellNotes,
            getRefundKeys,
            getSalePayments,
            dispatch,
            items,
            promotionDataByProductID,
            false,
            getSavings,
            bestPriceBookInfo,
            items,
            attribProps
          )
        } else {
          const getQuantity = nominatedPromo.getQuantity
          const spentAmount = nominatedPromo.spendAmount
          const isGetAllProd = nominatedPromo.isGetAllProd
          const isPromoAllProd = nominatedPromo.isPromoAllProd
          const isFree = nominatedPromo.isGetFree
          const applyQuantity = nominatedPromo.promoApplyQuantity
          const isDiscountPercentage =
            nominatedPromo.discountPercentage > 0 && !nominatedPromo.isGetAmount
              ? true
              : false
          const isAmount =
            nominatedPromo.amount > 0 && nominatedPromo.isGetAmount
              ? true
              : false
          const condProds =
            nominatedPromo &&
            nominatedPromo.condProds && // condition prods
            nominatedPromo.condProds.length > 0
              ? nominatedPromo.condProds
              : []
          const rewardProd =
            nominatedPromo &&
            nominatedPromo.rewardProd &&
            nominatedPromo.rewardProd.length > 0
              ? nominatedPromo.rewardProd
              : []
          if (isDiscountPercentage || isAmount || isFree) {
            let type = false
            if (isFree) {
              type = 'getItems_getFree'
            } else if (isDiscountPercentage) {
              type = 'getItems_getPercent'
            } else if (isAmount) {
              type = 'getItems_getAmount'
            }
            appliedPromotionObject = nominatedPromo
            appliedPromotionObject.isExistingPromotion = true
            const arrData = getItemsNominated(
              items,
              getReduxSaleProductJsonData,
              bestPriceBookInfo,
              condProds,
              rewardProd,
              applyQuantity,
              spentAmount,
              getQuantity,
              isGetAllProd,
              isPromoAllProd,
              getIsTaxExclusive,
              type
            )
            if (
              arrData &&
              Array.isArray(arrData) &&
              arrData.length > 0 &&
              type
            ) {
              promoProductsEffect(
                type,
                arrData, // only those prods upon which promo will apply
                appliedPromotionObject,
                builderType,
                getCustomerSearchData,
                getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscountPrice,
                formDiscountPercentage,
                formSellNotes,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                nominatedPromo,
                false,
                getSavings,
                bestPriceBookInfo,
                items,
                attribProps
              )
            } else {
              appliedPromotionObject = {}
              appliedPromotionObject.isExistingPromotion = false
            }
            const isComingExist =
              arrData && Array.isArray(arrData) && arrData.length > 0
                ? arrData.filter(fg => fg.key == items.key)
                : []
            let checkAmount = 0
            if (
              isComingExist &&
              isComingExist.length > 0 &&
              isComingExist[0].promoQuantity
            ) {
              const priceItem = getIsTaxExclusive
                ? bestPriceBookInfo.price
                : bestPriceBookInfo.price + bestPriceBookInfo.tax
              const amountData = calculatePromoGetItems(
                type,
                priceItem,
                appliedPromotionObject.discountPercentage,
                appliedPromotionObject.getAmount,
                isComingExist[0].displayQuantity,
                isComingExist[0].promoQuantity
              )
              checkAmount = amountData ? amountData : 0
              if (checkAmount) {
                appliedPromotionObject.amount = checkAmount
              }
            }
            // if promo is now not applicable then remove it from those prods
            const removeArr = checkIfPromoExist(
              items,
              getReduxSaleProductJsonData,
              arrData,
              nominatedPromo.name
            )
            if (removeArr && Array.isArray(removeArr) && removeArr.length > 0) {
              promoProductsEffect(
                'toRemovePromo',
                removeArr, // only those prods upon which promo will apply
                appliedPromotionObject,
                builderType,
                getCustomerSearchData,
                getReduxSaleProductJsonData, //getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscountPrice,
                formDiscountPercentage,
                formSellNotes,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                nominatedPromo,
                false,
                getSavings,
                bestPriceBookInfo,
                items,
                attribProps
              )
            }
            if (checkAmount) {
              // appliedPromotionObject = promotionDataByProductID;
              isPromotionApplied = true
            } else {
              // appliedPromotionObject = {};
              isPromotionApplied = false
              // referencePromotion = {};
            }
            resetBookPromoQuantity(items, getReduxSaleProductJsonData)
          }
        }
      } else {
        isPromotionApplied = false
      }
    } else {
      isPromotionApplied = false
    }
  } else {
    isPromotionApplied = false
  }

  return {
    appliedObj: appliedPromotionObject,
    isApplied: isPromotionApplied,
    refPromo: referencePromotion,
    isEntirePromoEffect: isEntirePromoEffect
  }
}
